/**
 * What the laser pointer has instead of controls (SRS C4).
 *
 * It has nothing to set — no colour, no thickness — so the space is used to say the
 * one thing about it a teacher needs to know: it is not ink, and it leaves nothing.
 */

export function LaserNote() {
  return (
    <section className="flex flex-col gap-2">
      <h3 className="text-sm font-medium text-text-secondary">Pointing</h3>
      <p className="text-xs text-text-secondary">
        Press and drag to point at something. The trail fades away on its own and is
        never part of the board, so it cannot be erased, saved or undone.
      </p>
    </section>
  );
}
